__turbopack_context__.v({
  "contentStack": "HomepageV2-module-scss-module__1bkupW__contentStack",
  "hpv2Blink": "HomepageV2-module-scss-module__1bkupW__hpv2Blink",
  "hpv2DemoBounce": "HomepageV2-module-scss-module__1bkupW__hpv2DemoBounce",
  "hpv2DemoFadeIn": "HomepageV2-module-scss-module__1bkupW__hpv2DemoFadeIn",
  "hpv2DemoProgress": "HomepageV2-module-scss-module__1bkupW__hpv2DemoProgress",
  "hpv2DemoScaleIn": "HomepageV2-module-scss-module__1bkupW__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "HomepageV2-module-scss-module__1bkupW__hpv2DemoSlideIn",
  "hpv2FadeLeft": "HomepageV2-module-scss-module__1bkupW__hpv2FadeLeft",
  "hpv2FadeRight": "HomepageV2-module-scss-module__1bkupW__hpv2FadeRight",
  "hpv2FadeUp": "HomepageV2-module-scss-module__1bkupW__hpv2FadeUp",
  "hpv2FloatA": "HomepageV2-module-scss-module__1bkupW__hpv2FloatA",
  "hpv2FloatB": "HomepageV2-module-scss-module__1bkupW__hpv2FloatB",
  "hpv2HeroFadeIn": "HomepageV2-module-scss-module__1bkupW__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "HomepageV2-module-scss-module__1bkupW__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "HomepageV2-module-scss-module__1bkupW__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "HomepageV2-module-scss-module__1bkupW__hpv2PriceShimmer",
  "hpv2PulseDot": "HomepageV2-module-scss-module__1bkupW__hpv2PulseDot",
  "hpv2ScaleUp": "HomepageV2-module-scss-module__1bkupW__hpv2ScaleUp",
  "main": "HomepageV2-module-scss-module__1bkupW__main",
});
